import React from 'react';
import { IIconProps, IconSizes, IconWidth } from './type';

const Paypal: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <rect
        x="0.5"
        y="0.5"
        width="35"
        height="23"
        rx="1.5"
        fill="white"
        stroke="#DFE4F3"
      />
      <g clipPath="url(#clip0_5676_6962)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.2796 11.8237L16.4368 10.8183L16.0867 10.8101H14.4144L15.5765 3.39106C15.5802 3.36859 15.5919 3.34774 15.6089 3.3329C15.6262 3.31806 15.6481 3.30992 15.6709 3.30992H18.4906C19.4267 3.30992 20.0727 3.50601 20.4099 3.8931C20.5681 4.07469 20.6687 4.2645 20.7175 4.47331C20.7686 4.69245 20.7695 4.95424 20.7196 5.27359L20.716 5.29682V5.50146L20.8741 5.5917C21.0073 5.6628 21.1131 5.74416 21.1942 5.83734C21.3295 5.99268 21.4169 6.19002 21.4539 6.4239C21.4922 6.6645 21.4795 6.95088 21.4169 7.27506C21.3448 7.6479 21.2282 7.97268 21.0706 8.23836C20.9258 8.48322 20.7413 8.68632 20.5221 8.8437C20.3128 8.99322 20.0643 9.10674 19.7832 9.1794C19.5108 9.2508 19.2003 9.2868 18.8597 9.2868H18.6403C18.4834 9.2868 18.331 9.34368 18.2114 9.44568C18.0914 9.54978 18.0121 9.69204 17.9877 9.84762L17.9711 9.93816L17.6933 11.7102L17.6808 11.7752C17.6774 11.7958 17.6717 11.8061 17.6633 11.813C17.6558 11.8194 17.645 11.8237 17.6345 11.8237H16.2796Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0238 5.32049C21.0154 5.37467 21.0058 5.43 20.995 5.48694C20.6231 7.4091 19.351 8.07318 17.7262 8.07318H16.8989C16.7002 8.07318 16.5328 8.21838 16.5019 8.41578L15.9583 11.8869C15.9382 12.0166 16.0374 12.1333 16.1672 12.1333H17.6345C17.8082 12.1333 17.9558 12.0062 17.9832 11.8337L17.9976 11.7586L18.2738 9.99354L18.2916 9.8967C18.3187 9.7236 18.4666 9.5964 18.6403 9.5964H18.8597C20.2813 9.5964 21.3941 9.01536 21.7194 7.33374C21.8552 6.63132 21.7849 6.04476 21.4254 5.6322C21.3166 5.50788 21.1816 5.40462 21.0238 5.32049Z"
          fill="#298FC2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6348 5.16431C20.578 5.14761 20.5193 5.13252 20.4592 5.11888C20.3988 5.10556 20.3369 5.09378 20.2732 5.08344C20.0501 5.04715 19.8057 5.02994 19.5439 5.02994H17.3339C17.2794 5.02994 17.2277 5.04232 17.1815 5.0647C17.0795 5.11404 17.0038 5.2112 16.9855 5.33014L16.5153 8.3283L16.5019 8.41578C16.5328 8.21838 16.7002 8.07318 16.8989 8.07318H17.7262C19.351 8.07318 20.6231 7.4091 20.995 5.48694C21.0058 5.43 21.0154 5.37467 21.0238 5.32049C20.9297 5.27023 20.8278 5.22722 20.7181 5.19059C20.6909 5.18152 20.663 5.17279 20.6348 5.16431Z"
          fill="#22284F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9855 5.33014C17.0038 5.2112 17.0795 5.11404 17.1815 5.0647C17.2277 5.04232 17.2794 5.02994 17.3339 5.02994H19.5439C19.8057 5.02994 20.0501 5.04715 20.2732 5.08344C20.3369 5.09378 20.3988 5.10556 20.4592 5.11888C20.5193 5.13252 20.578 5.14761 20.6348 5.16431C20.663 5.17279 20.6909 5.18152 20.7181 5.19059C20.8278 5.22722 20.9297 5.27023 21.0238 5.32049C21.1344 4.61016 21.0232 4.12651 20.6417 3.68855C20.2212 3.20635 19.4622 3 18.4909 3H15.6712C15.4729 3 15.3036 3.14522 15.2729 3.34292L14.0985 10.8382C14.0753 10.9865 14.189 11.1203 14.3375 11.1203H16.0783L16.9855 5.33014Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.97183 13.8643H5.91601C5.77531 13.8643 5.65566 13.9672 5.63368 14.107L4.8022 19.4147C4.7857 19.5195 4.86628 19.6138 4.97178 19.6138H5.95323C6.09395 19.6138 6.21359 19.511 6.23555 19.3709L6.45977 17.9392C6.48143 17.7991 6.60131 17.6962 6.74177 17.6962H7.39253C8.74673 17.6962 9.52829 17.0364 9.73247 15.7289C9.82445 15.1569 9.73637 14.7075 9.47027 14.3927C9.17813 14.0471 8.65985 13.8643 7.97183 13.8643ZM8.20895 15.8029C8.09657 16.5455 7.53293 16.5455 6.98795 16.5455H6.67769L6.89537 15.1585C6.90833 15.0746 6.98039 15.0129 7.06457 15.0129H7.20683C7.57805 15.0129 7.92821 15.0129 8.10917 15.226C8.21711 15.353 8.25011 15.5419 8.20895 15.8029Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1695 15.7388H13.1851C13.1012 15.7388 13.0287 15.8005 13.0158 15.8843L12.9722 16.1615L12.9034 16.0611C12.6903 15.7496 12.215 15.6455 11.7407 15.6455C10.6528 15.6455 9.72359 16.4752 9.54263 17.6389C9.44855 18.2193 9.58229 18.7744 9.90941 19.1615C10.2094 19.5174 10.6387 19.6658 11.1493 19.6658C12.026 19.6658 12.512 19.0983 12.512 19.0983L12.4681 19.3737C12.4516 19.479 12.5322 19.5734 12.6371 19.5734H13.5238C13.6648 19.5734 13.7839 19.4705 13.8061 19.3304L14.3382 15.9379C14.3551 15.8335 14.2747 15.7388 14.1695 15.7388ZM12.7972 17.668C12.7022 18.2342 12.2558 18.6143 11.6865 18.6143C11.4006 18.6143 11.1722 18.522 11.0254 18.3471C10.8799 18.1734 10.8247 17.9261 10.8709 17.6506C10.9597 17.0893 11.4135 16.6967 11.9742 16.6967C12.2537 16.6967 12.481 16.7903 12.6307 16.9666C12.7807 17.1449 12.8402 17.3937 12.7972 17.668Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3369 15.8236H18.3475C18.2531 15.8236 18.1645 15.8708 18.111 15.9499L16.7465 17.9734L16.1681 16.0288C16.1318 15.9071 16.0203 15.8236 15.894 15.8236H14.9219C14.8037 15.8236 14.7217 15.9399 14.7592 16.0519L15.8489 19.2715L14.8244 20.7276C14.7439 20.8423 14.825 21 14.9642 21H15.9523C16.0462 21 16.1339 20.954 16.1871 20.8766L19.4775 16.0945C19.5563 15.9802 19.4753 15.8236 19.3369 15.8236Z"
          fill="#28356A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.635 13.8643H20.5789C20.4386 13.8643 20.3189 13.9672 20.2969 14.107L19.4654 19.4147C19.4489 19.5195 19.5295 19.6138 19.6345 19.6138H20.6896C20.7875 19.6138 20.8714 19.5419 20.8867 19.4438L21.1227 17.9392C21.1443 17.7991 21.2643 17.6962 21.4046 17.6962H22.0552C23.4097 17.6962 24.191 17.0364 24.3954 15.7289C24.4877 15.1569 24.399 14.7075 24.133 14.3927C23.841 14.0471 23.3231 13.8643 22.635 13.8643ZM22.8722 15.8029C22.76 16.5455 22.1963 16.5455 21.6511 16.5455H21.3412L21.5591 15.1585C21.572 15.0746 21.6436 15.0129 21.728 15.0129H21.8702C22.2412 15.0129 22.5917 15.0129 22.7726 15.226C22.8806 15.353 22.9133 15.5419 22.8722 15.8029Z"
          fill="#298FC2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.8314 15.7388H27.8476C27.7631 15.7388 27.6913 15.8005 27.6787 15.8843L27.635 16.1615L27.5659 16.0611C27.3528 15.7496 26.8778 15.6455 26.4034 15.6455C25.3156 15.6455 24.3868 16.4752 24.2058 17.6389C24.112 18.2193 24.2451 18.7744 24.5722 19.1615C24.8728 19.5174 25.3014 19.6658 25.8122 19.6658C26.6887 19.6658 27.1748 19.0983 27.1748 19.0983L27.1309 19.3737C27.1144 19.479 27.1949 19.5734 27.3005 19.5734H28.187C28.3273 19.5734 28.447 19.4705 28.469 19.3304L29.0013 15.9379C29.0176 15.8335 28.937 15.7388 28.8314 15.7388ZM27.4592 17.668C27.3649 18.2342 26.9178 18.6143 26.3485 18.6143C26.0632 18.6143 25.8341 18.522 25.6874 18.3471C25.542 18.1734 25.4872 17.9261 25.5329 17.6506C25.6222 17.0893 26.0755 16.6967 26.6362 16.6967C26.9157 16.6967 27.143 16.7903 27.2927 16.9666C27.4432 17.1449 27.5027 17.3937 27.4592 17.668Z"
          fill="#298FC2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.9101 14.0101L29.0663 19.4149C29.0498 19.5197 29.1303 19.6141 29.2352 19.6141H30.0836C30.2246 19.6141 30.3442 19.5113 30.3658 19.3711L31.1978 14.0637C31.2145 13.9589 31.1339 13.8643 31.0289 13.8643H30.0791C29.9952 13.8645 29.9231 13.9263 29.9101 14.0101Z"
          fill="#298FC2"
        />
      </g>
      <defs>
        <clipPath id="clip0_5676_6962">
          <rect
            width="26.4"
            height="18"
            fill="white"
            transform="translate(4.80005 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Paypal;
